import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class RatingData extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'RatingData'
  // Define default properties here
  static instanceDefaults () {
    return {
      color: '#5e3b4f',
      icon: 'TemaMiljosertifisering',
      title: 'Miljøsertifisering',
      sub_categories_count: '9',
      clicked: false,
      itemStyle: {
        opacity: 1,
      },
      value: 3,
      label: '01',
      visionValue: 0.5,
    }
  }
}
const servicePath = 'rating-data'
const servicePlugin = makeServicePlugin({
  Model: RatingData,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
  },
  after: {
    all: [],
    find: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
  },
})

export default servicePlugin
